import React, { useState } from 'react';
import millify from 'millify';
import { Link } from 'react-router-dom';
import { Card, Row, Col, Input, Typography } from 'antd';

import { useGetCryptosQuery } from '../features/api';
import { CircularProgress, TextField } from '@mui/material';
import { dark } from '@mui/material/styles/createPalette';
import { useEffect } from 'react';

const Cryptocurrencies = ({simplified}) => {

    const count = simplified ? 10 : 100
    const { data: cryptosList, isFetching } = useGetCryptosQuery(count);

    const [searchTerm, setSearchTerm] = useState('')

    const [cryptos, setCryptos] = useState([])

    console.log("CRYPTOS", cryptos)

    useEffect(() => {
        const filteredData = cryptosList?.data?.coins.filter((coin) => coin.name.toLowerCase().includes(searchTerm.toLowerCase()))
        setCryptos(filteredData)
    }, [cryptosList, searchTerm])
    

    return (
        <>
            {isFetching ? <CircularProgress color="secondary" /> :

            <>
            <Typography variant="h1" component="h1">Cryptocurrencies</Typography>  
                {!simplified && (
                        <TextField sx={{my: 2}} placeholder="Search Cryptocurrency" onChange={(e) => setSearchTerm(e.target.value)}/>
                )}

                <Row gutter={[32, 32]} className='crypto-card-container'>
                    {cryptos?.map((currency) => (
                        <Col sx={24} sm={12} lg={6} className='crypto-card' key={currency.id} >
                            <Link to={`/coin/${currency?.uuid}`}>
                                <Card 
                                title={`${currency.rank}. ${currency.name}`}
                                extra={<img className='crypto-image' src={currency.iconUrl} style={{height:'40px'}}/>}
                                hoverable
                                >
                                    <p>Price: {millify(currency.price)}</p>
                                    <p>Price: {millify(currency.marketCap)}</p>
                                    <p>Price: {millify(currency.change)}%</p>
                                </Card>
                            </Link>
                        </Col>
                    ))}
                </Row>
            </>


            }
        </>

    )
}

export default Cryptocurrencies
